var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-checkbox',{attrs:{"label":_vm.option.label,"disable":_vm.disable},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }